import { baseRulesMdString } from '@pkg/components/Sections/Admin/Fantasy/Rules/base-rules-md-string';

import {
    type CompetitionQnA,
    type CreateCompetition,
    type DynamicCriteriaType,
    type GameCriteriaValues,
    type Prize,
} from '@app/client/common/structs';

import { getMashedUrl } from '../mediaMasher';

const DEFAULT_DYNAMIC_CRITERIA: DynamicCriteriaType = [
    { MinimumSalesCount: { amount: 10, period_in_days: 7 } },
    { MinimumAssetCount: { amount: 100 } },
    { MinimumAssetsOnSalePercentage: { percent: 1 } },
    { MinimumUniqueCollectionOwnerPercentage: { percent: 3 } },

    { AptosMinimumSalesCount: { amount: 10, period_in_days: 7 } },
    { AptosMinimumAssetCount: { amount: 100 } },
    { AptosMinimumAssetsOnSalePercentage: { percent: 1 } },
    { AptosMinimumUniqueCollectionOwnerPercentage: { percent: 3 } },

    { PolygonMinimumSalesCount: { amount: 10, period_in_days: 7 } },
    { PolygonMinimumAssetCount: { amount: 100 } },
    { PolygonMinimumAssetsOnSalePercentage: { percent: 1 } },
    { PolygonMinimumUniqueCollectionOwnerPercentage: { percent: 3 } },
];

export const DEFAULT_COMPETITION_CRITERIA_VALUES: GameCriteriaValues = {
    max_value: 100000,
    max_assets: 999999999999999,
    max_player_count: 10000,
    max_user_submissions: 999999999999999,
    min_collection_count: 1,
};

const DEFAULT_REFERRAL_PAYOUT = 10000;

export const FALLBACK_HEADER_IMG_SRC =
    getMashedUrl({
        width: 100,
        url: 'https://i.pinimg.com/originals/33/71/0f/33710f96179e35d754d4582e8af809b0.jpg',
    }) || 'https://i.pinimg.com/originals/33/71/0f/33710f96179e35d754d4582e8af809b0.jpg';

export const DEFAULT_COMPETITION_FORM_VALUES: CreateCompetition = {
    name: '',
    game_label: '',
    description: '',
    sponsor: '',
    landing_page_url: '',
    submission_starts_at: '',
    submission_ends_at: '',
    ends_at: '',
    dynamic_criteria: DEFAULT_DYNAMIC_CRITERIA,
    prizes: [],
    header_images: [FALLBACK_HEADER_IMG_SRC],
    questions_and_answers: [],
    rules: baseRulesMdString,
    referee_payout: DEFAULT_REFERRAL_PAYOUT,
    referrer_payout: DEFAULT_REFERRAL_PAYOUT,
    referral_max_per_user: 5,
    ...DEFAULT_COMPETITION_CRITERIA_VALUES,
};

export const DEFAULT_PRIZE_FORM_VALUES: Prize = {
    reward: '',
    name: 'Fantasy Reward',
    description: '',
    rank: 1,
};

export const DEFAULT_QNA_FORM_VALUES: CompetitionQnA = {
    question: '',
    answers: [],
};
